import { NgModule, Type, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { TextboxModule } from './textbox/textbox.module';
import { DYNAMIC_FORM_CONTROL_MAP_FN, DynamicFormControlModel, DynamicFormControl, DYNAMIC_VALIDATORS, ValidatorFactory, HIDDEN_MATCHER_PROVIDER } from '@ng-dynamic-forms/core';
import { DynamicTextboxComponent } from './textbox/dynamic-textbox.component';
import { WorkflowComponentsService } from './workflow-components.service';
import { DropdownModule } from './dropdown/dropdown.module';
import { ToggleModule } from './toggle/toggle.module';
import { NumericTextboxModule } from './numeric-textbox/numeric-textbox.module';
import { Validator, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NoWhitespaceValidator } from './@validators/no-whitespace.validator';
import { DynamicTextareaComponent } from './textarea/dynamic-textarea.component';
import { TextareaModule } from './textarea/textarea.module';
import { DatePickerModule } from './datepicker/datepicker.module';
import { DatasourcePickerModule } from './datasource-picker/datasource-picker.module';
import { DynamicDatasourcePickerComponent } from './datasource-picker/dynamic-datasource-picker.component';
import { CheckboxModule } from './checkbox/checkbox.module';
import { DynamicCheckboxComponent } from './checkbox/dynamic-checkbox.component';
import { RadioboxModule } from './radiobox/radiobox.module';
import { ElectronicSignatureModule } from './electronic-signature/electronic-signature.module';
import { DynamicElectronicSignatureComponent } from './electronic-signature/dynamic-electronic-signature.component';
import { CodeScannerModule } from './code-scanner/code-scanner.module';
import { DynamicCodeScannerComponent } from './code-scanner/dynamic-code-scanner.component';
import { DocumentScannerModule } from './document-scanner/document-scanner.module';
import { UploadFileModule } from './upload-file/upload-file.module';
import { CameraModule } from './camera/camera.module';
import { DynamicCameraComponent } from './camera/dynamic-camera.component';
import { InputGridModule } from './input-grid/input-grid.module';
import { FamocoScanLaserModule } from './famoco-scan-laser/famoco-scan-laser.module';
import { DynamicDropdownComponent } from './dropdown/dynamic-dropdown.component';
import { DynamicToggleComponent } from './toggle/dynamic-toggle.component';
import { DynamicNumericTextboxComponent } from './numeric-textbox/dynamic-numeric-textbox.component';
import { DynamicDatePickerComponent } from './datepicker/dynamic-datepicker.component';
import { DynamicRadioboxComponent } from './radiobox/dynamic-radiobox.component';
import { DynamicDocumentScannerComponent } from './document-scanner/dynamic-document-scanner.component';
import { DynamicUploadFileComponent } from './upload-file/dynamic-upload-file.component';
import { DynamicInputGridComponent } from './input-grid/dynamic-input-grid.component';
import { DynamicFamocoScanLaserComponent } from './famoco-scan-laser/dynamic-famoco-scan-laser.component';
import { DynamicInputGridColumnsBuilderComponent } from './input-grid/input-grid-columns-builder/dynamic-input-grid-columns-builder.component';
import { DatasourceComponentsModule } from '../datasource-components/datasource-components.module';
import { ExpressionBuilderModule } from './expression-builder/expression-builder.module';
import { ChipsInputModule } from './chips-input/chips-input.module';
import { DynamicChipsInputComponent } from './chips-input/dynamic-chips-input.component';
import { RichAutocompleteModule } from './rich-autocomplete/rich-autocomplete.module';
import { DynamicRichAutocompleteComponent } from './rich-autocomplete/dynamic-rich-autocomplete.component';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from '../auth/auth.interceptor';
import { GedDesignerModule } from './ged-designer/ged-designer.module';
import { DynamicGedDesignerComponent } from './ged-designer/dynamic-ged-designer.component';
import { GedModule } from './ged/ged.module';
import { DynamicGedComponent } from './ged/dynamic-ged.component';
import { BarcodesVerificationModule } from './@soudotec/barcodes-verification/barcodes-verification.module';
import { DynamicBarcodesVerificationComponent } from './@soudotec/barcodes-verification/dynamic-barcodes-verification.component';
import { CommandGridInputModule } from './@soudotec/command-gridinput/command-gridinput.module';
import { DynamicCommandGridInputComponent } from './@soudotec/command-gridinput/dynamic-command-gridinput.component';
import { DynamicInventoryInputComponent } from './@soudotec/inventory-input/dynamic-inventory-input.component';
import { InventoryInputModule } from './@soudotec/inventory-input/inventory-input.module';
import { DynamicInputGridColumnsDatasourceMappingComponent } from './input-grid/input-grid-columns-datasource-mapping/dynamic-input-grid-columns-datasource-mapping.component';
import { MibemCommandInputModule } from './@mibem/mibem-command-input/mibem-command-input.module';
import { DynamicMibemCommandInputComponent } from './@mibem/mibem-command-input/dynamic-mibem-command-input.component';
import { ExpressionEvaluatorModule } from './expression-evaluator/expression-evaluator.module';
import { DynamicExpressionEvaluatorComponent } from './expression-evaluator/dynamic-expression-evaluator.component';
import { DynamicDatasourceDatasSelectionComponent } from './datasource-datas-selection/dynamic-datasource-datas-selection.component';
import { DynamicInputGridFunctionsComponent } from './input-grid-functions/dynamic-input-grid-functions.component';
import { InputGridFunctionsModule } from './input-grid-functions/input-grid-functions.module';
import { DynamicLabelComponent } from './label/dynamic-label.component';
import { LabelModule } from './label/label.module';
import { DynamicInputGridFunctionsFiltersComponent } from './input-grid-functions/input-grid-functions-filters/dynamic-input-grid-functions-filters.component';
import { DynamicReceptionMarchandiseComponent } from './@soudotec/reception-marchandise/dynamic-reception-marchandise.component';
import { ReceptionMarchandiseModule } from './@soudotec/reception-marchandise/reception-marchandise.module';
import { NewlandScannerModule } from './newland-scanner/newland-scanner.module';
import { DynamicNewlandScannerComponent } from './newland-scanner/dynamic-newland-scanner.component';
import { DynamicPageBuilderTextboxComponent } from './@page-builder/textbox/dynamic-page-builder-textbox.component';
import { DynamicPageBuilderNumericTextboxComponent } from './@page-builder/numeric-textbox/dynamic-page-builder-numeric-textbox.component';
import { DynamicPageBuilderLabelComponent } from './@page-builder/label/dynamic-page-builder-label.component';
import { DynamicPageBuilderDropdownComponent } from './@page-builder/dropdown/dynamic-page-builder-dropdown.component';
import { DynamicPageBuilderDatasourcesComponent } from './@page-builder/datasources/dynamic-page-builder-datasources.component';
import { DynamicPageBuilderBarcodeComponent } from './@page-builder/barcode/dynamic-page-builder-barcode.component';
import { DynamicPageBuilderImageComponent } from './@page-builder/image/dynamic-page-builder-image.component';
import { DynamicPageBuilderQRCodeComponent } from './@page-builder/qrcode/dynamic-page-builder-qrcode.component';
import { DynamicPageBuilderFilePickerComponent } from './@page-builder/file-picker/dynamic-page-builder-file-picker.component';
import { DynamicPageBuilderTextareaComponent } from './@page-builder/textarea/dynamic-page-builder-textarea.component';
import { DynamicPageBuilderHSeparatorComponent } from './@page-builder/hseparator/dynamic-page-builder-hseparator.component';
import { PageBuilderComponent } from './@page-builder/page-builder.component';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../material.module';
import { PageBuilderTextboxModule } from './@page-builder/textbox/page-builder-textbox.module';
import { PageBuilderNumericTextboxModule } from './@page-builder/numeric-textbox/page-builder-numeric-textbox.module';
import { PageBuilderLabelModule } from './@page-builder/label/page-builder-label.module';
import { PageBuilderDropdownModule } from './@page-builder/dropdown/page-builder-dropdown.module';
import { PageBuilderDatasourcesModule } from './@page-builder/datasources/page-builder-datasources.module';
import { PageBuilderBarcodeModule } from './@page-builder/barcode/page-builder-barcode.module';
import { PageBuilderImageModule } from './@page-builder/image/page-builder-image.module';
import { PageBuilderQRCodeModule } from './@page-builder/qrcode/page-builder-qrcode.module';
import { PageBuilderFilePickerModule } from './@page-builder/file-picker/page-builder-file-picker.module';
import { PageBuilderTextareaModule } from './@page-builder/textarea/page-builder-textarea.module';
import { PageBuilderHSeparatorModule } from './@page-builder/hseparator/page-builder-hseparator.module';
import { PageBuilderComponentsService } from './@page-builder/page-builder-components.service';
import { DynamicFormsIonicUIModule } from '@ng-dynamic-forms/ui-ionic';
import { PageBuilderResultComponent } from './@page-builder/page-builder-result/page-builder-result.component';
import { PageBuilderResultDialogComponent } from './@page-builder/page-builder-result-dialog/page-builder-result-dialog.component';
import { BERetailInventoryInputModule } from './@be_retail/inventory-input/be-retail-inventory-input.module';
import { DynamicBERetailInventoryInputComponent } from './@be_retail/inventory-input/dynamic-be-retail-inventory-input.component';
import { AgendaPlannerModule } from './@blackhawk/agenda-planner/agenda-planner.module';
import { DynamicAgendaPlannerComponent } from './@blackhawk/agenda-planner/dynamic-agenda-planner.component';
import { DynamicBHQrCodeScannerComponent } from './@blackhawk/bh-qrcode-scanner/dynamic-bh-qrcode-scanner.component';
import { DynamicBHQrCodeSiteScannerComponent } from './@blackhawk/bh-qrcode-site-scanner/dynamic-bh-qrcode-site-scanner.component';
import { BHQrCodeScannerModule } from './@blackhawk/bh-qrcode-scanner/bh-qrcode-scanner.module';
import { BHQrCodeSiteScannerModule } from './@blackhawk/bh-qrcode-site-scanner/bh-qrcode-site-scanner.module';
import { DynamicMultipackCommercialPlanningComponent } from "./@multipack/commercial-planning/dynamic-commercial-planning.component";
import { MultipackCommercialPlanningModule } from "./@multipack/commercial-planning/commercial-planning.module";
import { KanbanModule } from "./kanban/kanban.module";
import { DynamicKanbanComponent } from "./kanban/dynamic-kanban.component";
import { SoudotecItemsInputModule } from "./@soudotec/items-input/soudotec-items-input.module";
import { DynamicSoudotecItemsInputComponent } from "./@soudotec/items-input/dynamic-soudotec-items-input.component";
import { SoudotecEmplacementInputModule } from "./@soudotec/emplacement-input/soudotec-emplacement-input.module";
import { DynamicSoudotecEmplacementInputComponent } from "./@soudotec/emplacement-input/dynamic-soudotec-emplacement-input.component";

@NgModule({
    declarations: [PageBuilderComponent, PageBuilderResultComponent, PageBuilderResultDialogComponent],
    imports: [
        CommonModule,
        FormsModule,
        MaterialModule,
        DynamicFormsIonicUIModule,
        ReactiveFormsModule,
        DatasourceComponentsModule,
        TextboxModule,
        DropdownModule,
        ToggleModule,
        NumericTextboxModule,
        TextareaModule,
        DatePickerModule,
        DatasourcePickerModule,
        CheckboxModule,
        RadioboxModule,
        ElectronicSignatureModule,
        CodeScannerModule,
        DocumentScannerModule,
        UploadFileModule,
        CameraModule,
        InputGridModule,
        FamocoScanLaserModule,
        ExpressionBuilderModule,
        ExpressionEvaluatorModule,
        ChipsInputModule,
        RichAutocompleteModule,
        GedDesignerModule,
        GedModule,
        BarcodesVerificationModule,
        CommandGridInputModule,
        InventoryInputModule,
        MibemCommandInputModule,
        ReceptionMarchandiseModule,
        DatasourceComponentsModule,
        InputGridFunctionsModule,
        LabelModule,
        NewlandScannerModule,
        BERetailInventoryInputModule,
        AgendaPlannerModule,
        BHQrCodeScannerModule,
        BHQrCodeSiteScannerModule,
        MultipackCommercialPlanningModule,
        KanbanModule,
        SoudotecItemsInputModule,
        SoudotecEmplacementInputModule,

        // *****
        PageBuilderTextboxModule,
        PageBuilderNumericTextboxModule,
        PageBuilderLabelModule,
        PageBuilderDropdownModule,
        PageBuilderDatasourcesModule,
        PageBuilderBarcodeModule,
        PageBuilderImageModule,
        PageBuilderQRCodeModule,
        PageBuilderFilePickerModule,
        PageBuilderTextareaModule,
        PageBuilderHSeparatorModule,
    ],
    exports: [
        RichAutocompleteModule,
        PageBuilderComponent,
        PageBuilderResultComponent,
        PageBuilderResultDialogComponent
    ],
    entryComponents: [
        PageBuilderResultDialogComponent
    ], 
    providers: [
        {provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true},
        WorkflowComponentsService,
        HIDDEN_MATCHER_PROVIDER,
        {
            provide: DYNAMIC_VALIDATORS,
            // @ts-ignore
            useValue: new Map<string, Validator | ValidatorFactory>([
                ["no_whitespace", NoWhitespaceValidator],
            ])
        },
        { 
            provide: DYNAMIC_FORM_CONTROL_MAP_FN,
            useValue: (model: DynamicFormControlModel): Type<DynamicFormControl> | null  => {
                switch (model.type) {
                    case 'label': return DynamicLabelComponent;
                    case 'textbox': return DynamicTextboxComponent;
                    case 'dropdown': return DynamicDropdownComponent;
                    case 'toggle': return DynamicToggleComponent;
                    case 'numeric_textbox': return DynamicNumericTextboxComponent;
                    case 'textarea': return DynamicTextareaComponent;
                    case 'datepicker': return DynamicDatePickerComponent;
                    case 'datasource_picker': return DynamicDatasourcePickerComponent;
                    case 'checkbox': return DynamicCheckboxComponent;
                    case 'radiobox': return DynamicRadioboxComponent;
                    case 'electronic_signature': return DynamicElectronicSignatureComponent;
                    case 'code_scanner': return DynamicCodeScannerComponent;
                    case 'document_scanner': return DynamicDocumentScannerComponent;
                    case 'upload_file': return DynamicUploadFileComponent;
                    case 'camera': return DynamicCameraComponent;
                    case 'input_grid': return DynamicInputGridComponent;
                    case 'input_grid_columns_builder': return DynamicInputGridColumnsBuilderComponent;
                    case 'input_grid_columns_datasource_mapping': return DynamicInputGridColumnsDatasourceMappingComponent;
                    case 'input_grid_functions': return DynamicInputGridFunctionsComponent;
                    case 'input_grid_functions_filters': return DynamicInputGridFunctionsFiltersComponent;
                    case 'famoco_scan_laser': return DynamicFamocoScanLaserComponent;
                    case 'chips_input': return DynamicChipsInputComponent;
                    case 'rich_autocomplete': return DynamicRichAutocompleteComponent;
                    case 'ged_designer': return DynamicGedDesignerComponent;
                    case 'ged': return DynamicGedComponent;
                    case 'soudotec_barcodes_verification': return DynamicBarcodesVerificationComponent;
                    case 'soudotec_command_gridinput': return DynamicCommandGridInputComponent;
                    case 'soudotec_inventory_input': return DynamicInventoryInputComponent;
                    case 'soudotec_reception_marchandise': return DynamicReceptionMarchandiseComponent;
                    case 'soudotec_items_input': return DynamicSoudotecItemsInputComponent;
                    case 'soudotec_emplacement_input': return DynamicSoudotecEmplacementInputComponent;
                    case 'mibem_command_input': return DynamicMibemCommandInputComponent;
                    case 'expression_evaluator': return DynamicExpressionEvaluatorComponent;
                    case 'datasource_datas_selection': return DynamicDatasourceDatasSelectionComponent;
                    case 'newland_scanner': return DynamicNewlandScannerComponent;
                    case 'be_retail_inventory_input': return DynamicBERetailInventoryInputComponent;
                    case 'agenda_planner': return DynamicAgendaPlannerComponent;
                    case 'bh_qr_code_scanner': return DynamicBHQrCodeScannerComponent;
                    case 'bh_qr_code_site_scanner': return DynamicBHQrCodeSiteScannerComponent;
                    case 'multipack_commercial_planning': return DynamicMultipackCommercialPlanningComponent;
                    case 'kanban': return DynamicKanbanComponent;

                    //****** */
                    case 'page_builder_textbox': return DynamicPageBuilderTextboxComponent;
                    case 'page_builder_numeric_textbox': return DynamicPageBuilderNumericTextboxComponent;
                    case 'page_builder_label': return DynamicPageBuilderLabelComponent;
                    case 'page_builder_dropdown': return DynamicPageBuilderDropdownComponent;
                    case 'page_builder_datasources': return DynamicPageBuilderDatasourcesComponent;
                    case 'page_builder_barcode': return DynamicPageBuilderBarcodeComponent;
                    case 'page_builder_image': return DynamicPageBuilderImageComponent;
                    case 'page_builder_qrcode': return DynamicPageBuilderQRCodeComponent;
                    case 'page_builder_file_picker': return DynamicPageBuilderFilePickerComponent;
                    case 'page_builder_textarea': return DynamicPageBuilderTextareaComponent;
                    case 'page_builder_h_separator': return DynamicPageBuilderHSeparatorComponent;
                }
            }
        },

        //********* */
        PageBuilderComponentsService,
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA
    ],
})
export class WorkflowComponentsModule {
}